import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import auth, { GProvider } from "@/config/auth";
import store from '@/store';
import { redirect } from '@/utils/RedirectUtils';
let ButtonGoogle = class ButtonGoogle extends Vue {
    constructor() {
        super(...arguments);
        this.menu = store.state.menu;
        this.displayError = false;
        this.error = '';
    }
    authWithGoogleProvider() {
        this.$analytics.logEvent('login', {
            method: 'Google'
        });
        auth.signInWithRedirect(GProvider);
    }
    async mounted() {
        const result = await auth.getRedirectResult();
        if (result.user) {
            redirect();
        }
        else {
            this.error = 'Error al registrar usuario con gmail';
        }
    }
};
__decorate([
    Prop({ default: '' })
], ButtonGoogle.prototype, "title", void 0);
ButtonGoogle = __decorate([
    Component
], ButtonGoogle);
export default ButtonGoogle;
